import React from 'react'
import Flex from 'shared/library/atoms/Flex'
import Icon from 'shared/library/atoms/Icon'
import { H4 } from 'library/atoms/Typography'
import useTranslation from 'next-translate/useTranslation'

const SecuredBadge = () => {
  const { t } = useTranslation('common')

  return (
    <Flex alignItems="center">
      <Icon name="lock" mr={3} />
      <H4>{t('secured')}</H4>
    </Flex>
  )
}

export default SecuredBadge
